import { render, staticRenderFns } from "./BrElem.vue?vue&type=template&id=66d58ee5"
import script from "./BrElem.vue?vue&type=script&lang=js"
export * from "./BrElem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports